import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ children }) => (
  <div className="c-membership-container">{children}</div>
);

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/Container.jsx